// src/components/panels/ItemActionsPanel.js
import React from 'react';
import ActionMenu from '../ActionMenu';

const ItemActionsPanel = ({ actionMenuConfig, areButtonsDisabled, fileInputRef }) => {
    return (
        <div className="panel imports-actions-panel">
            <h3 className="panel-title">Item Actions</h3>
            <div className="panel-content">
                <ActionMenu menuConfig={actionMenuConfig} disabled={areButtonsDisabled} />
                <input type="file" ref={fileInputRef} style={{ display: 'none' }} />
            </div>
        </div>
    );
};

export default ItemActionsPanel;